// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"src_app_layout_layout_module_ts":"a134daf1b3ef5491","src_app_layout_dashboard_dashboard_module_ts":"15a7dfe4a59edbf8"}[chunkId] + ".js";
};